<div class="container"
  [style]="bannerInput.background ? ('background-color:' + bannerInput.background + ';') : 'background-color: #002D74;'">
  <p [style]="bannerInput.colorText ? ('color:' + bannerInput.colorText + ';') : ''">{{ bannerInput.text }}</p>
  @if(bannerInput.img) {
  <img [class]="bannerInput.processor + '_design'" [src]="bannerInput.img" alt="Processor" />
  }
</div>